import React from 'react';
import Branches from '../components/branches/Branches';

const BranchesPage: React.FC = () => {
  return <Branches />;
};

export default BranchesPage; 